export default __webpack_public_path__ + "static/media/Group 10752_hover.68532cdc.svg";